import * as Yup from 'yup';

export const schema = Yup.object().shape({
  country: Yup.number().required(),
  mall: Yup.number().required(),
  rule: Yup.string().required(),
  rule_type: Yup.number().required(),
  active: Yup.boolean().required()
});

export const formInitialState = {
  country: '',
  mall: '',
  rule: '',
  rule_type: '',
  active: false
};

export const formErrorInitialState = {
  countryError: false,
  mallError: false,
  ruleError: false,
  rule_typeError: false,
  activeError: false
};
